import { getAuthorizationHeader } from "@brandclub/common-ui";
import axios from "../../../utils/axios";

export const generateBrandAppLoginCode = async (
  req: {
    accessToken: string;
    accessTokenExpiresIn: number;
    refreshToken: string;
    refreshTokenExpiresIn: number;
  },
  abortSignal?: AbortController
) => {
  const res = await axios.post<{ loginCode: string }>(
    "/brandapp/generateBrandAppLoginCode",
    req,
    {
      headers: {
        ...(await getAuthorizationHeader()),
      },
      signal: abortSignal?.signal,
    }
  );
  return res?.data;
};
